<template>
    <div>
        <b-form-group v-if="!readonly">
            <b-button size="sm" variant="light" title="Markera alla terminaler" @click="selall(true)"><b-icon-check-all></b-icon-check-all></b-button>
            <b-button size="sm" variant="light" title="Avmarkera alla terminaler" @click="selall(false)"><b-icon-circle></b-icon-circle></b-button>
            <b-form-checkbox v-if="allterminals" v-for="t in allterminals" v-model="userterminals" :key="t.terminalId"
                :value="t.terminalId" :readonly="readonly" @input="oninput">
                {{ t.terminalName }}
            </b-form-checkbox>
        </b-form-group>
        <!-- {{ userterminals }} -->
        <div v-if="readonly">
            {{ GetUserTerminals() }}
        </div>
    </div>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'userterminals',
    props: { value: Array, readonly: Boolean },
    data() {
        return {
            allterminals: [],
            userterminals:[],
            //selected: [],
        }
    },
    created() {
        api.get("/api/Booking/GetTerminals").then((res) => {
            this.allterminals = [];
            res.data.map(x => {
                this.allterminals.push(x);
            });
        });
        this.userterminals = JSON.parse(JSON.stringify(this.value));
    },
    methods: {
        GetUserTerminals() {
            var res = [];
            if(this.userterminals && this.allterminals) {
                this.userterminals.forEach(t => {
                    var term = this.allterminals.find(x => x.terminalId == t);                    
                    if(term)                                        
                        res.push(term.terminalName);
                    else 
                        res.push(`(${t})`);
                });
            }
            return res.join(', ');
        },
        oninput() {
            this.$emit('input', this.userterminals);
        },
        selall(v) {
            if(this.allterminals) {
                let res =[];
                if(v)
                    this.allterminals.forEach(x=> {
                        res.push(x.terminalId);
                    });
                this.userterminals = res;
                this.oninput();
            }
        }
    }
}

</script>